let features
let environment = process.env.REACT_APP_NODE_ENV
if (environment === 'pull_request' || environment === 'local') {
  environment = 'development'
}

const { REACT_APP_FEATURE_TOGGLES_URL } = process.env

const fetchFeatures = async env => {
  const currentDate = new Date()
  await fetch(`${REACT_APP_FEATURE_TOGGLES_URL}/${env}.json?v=${currentDate.getTime()}`)
    .then(response => response.json())
    .then(response => {
      features = { ...response }
    })
    .catch()
}

const getFeature = async feature => {
  await fetchFeatures(environment)
  try {
    return !!features && features[feature]
  } catch {
    return false
  }
}

const FEATURE_BANNER_SURVEY_MONKEY = 'banner_survey_monkey'
const FEATURE_CARDS_LAYOUT_CONFIG_BY_SLUG = 'cards_layout_config_by_slug'
const FEATURE_TEACHERS_SERVICES_LANDING_PAGE = 'teachers_services_landing_page'

export {
  fetchFeatures,
  getFeature,
  FEATURE_BANNER_SURVEY_MONKEY,
  FEATURE_CARDS_LAYOUT_CONFIG_BY_SLUG,
  FEATURE_TEACHERS_SERVICES_LANDING_PAGE,
}
